<template>
  <div class="field">
    <div class="control">
      <input
        class="is-checkradio"
        :id="`checkbox-${config.id}`"
        type="checkbox"
        :checked="config.value"
        v-on:change="updateValue($event.target.value)"
      />
      <label :for="`checkbox-${config.id}`">{{config.label}}</label>
    </div>
    <span class="label-error" v-if="config.error">{{config.message}}</span>
  </div>
</template>
<style  lang="scss" >
@import "./src/bulma/form/checkradio";
</style>
<script lang="ts">
// @ is an alias to /src
import { Component, Prop, Vue } from 'vue-property-decorator';

import { ICheckbox } from './';

@Component({
  name: 'Checkbox'
})
class Checkbox extends Vue {
  @Prop({ required: true }) public config!: ICheckbox;
  public updateValue(value: boolean) {
    this.config.value = !this.config.value;
    this.$emit('input', this.config.value);
    if (this.config.onClick) {
      this.config.onClick();
    }
  }
}
export default Checkbox;
</script>